import styled from "styled-components";

import { colors } from "ui-components";

const AccountLinksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 30px 0;

  a {
    /* Divider between Footer links */
    &:not(:last-of-type) {
      border-right: 1px solid ${({ theme }) => theme.colors.mediumDarkGrey};
    }
  }
`;

const AccountLink = styled.a`
  padding: 0 12px;
  color: ${colors.mediumDarkGrey};
  /* TODO: Create a font extender */
  font-size: ${({ theme }) => theme.fonts.sizes.Text4};
  font-family: ${({ theme }) => theme.fonts.family.bookText};
  font-weight: ${({ theme }) => theme.fonts.weight.bookText};
`;

export { AccountLink, AccountLinksWrapper };



// WEBPACK FOOTER //
// ./src/common/components/AccountLinks/styled.js